function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import MedicalCardIcon from 'svg/medical-card.svg';
import App from 'modules/App';
import Visit from 'modules/Visit';
import * as constants from '../../constants';
import messages from '../../messages';
var _React_PureComponent;
class AdditionalMeasurementsBtn extends (_React_PureComponent = React.PureComponent) {
    onOpenFloatingModal() {
        if (this.props.floatingModal) {
            this.props.onCloseFloatingModal();
            return;
        }
        this.props.onOpenFloatingModal();
    }
    onOpenModal() {
        if (this.props.openModalId === constants.ADDITIONAL_MEASUREMENTS_MODAL) {
            this.props.onCloseModal();
            return;
        }
        this.props.onOpenModal();
    }
    onClick(evt) {
        evt.stopPropagation();
        if (this.props.activeVisit) {
            this.onOpenFloatingModal();
        } else {
            this.onOpenModal();
        }
    }
    render() {
        return /*#__PURE__*/ _jsxs(Button, {
            id: "AdditionalMeasurementsBtn",
            styleModifier: "transparent-primary",
            onClick: (evt)=>this.onClick(evt),
            children: [
                /*#__PURE__*/ _jsx(MedicalCardIcon, {
                    className: "btn__icon mr-2"
                }),
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.additionalMeasurements))
            ]
        });
    }
}
_define_property(AdditionalMeasurementsBtn, "propTypes", {
    // Implicit props
    activeVisit: Visit.shapes.visit,
    openModalId: PropTypes.string,
    floatingModal: App.shapes.floatingModal,
    // Implicit actions
    onOpenModal: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onOpenFloatingModal: PropTypes.func.isRequired,
    onCloseFloatingModal: PropTypes.func.isRequired
});
const mapStateToProps = (state)=>({
        activeVisit: Visit.selectors.activeVisit(state),
        openModalId: App.selectors.modal(state),
        floatingModal: App.selectors.floatingModalSelector(constants.ADDITIONAL_MEASUREMENTS_FM)(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: ()=>dispatch(App.actions.openModal(constants.ADDITIONAL_MEASUREMENTS_MODAL)),
        onCloseModal: ()=>dispatch(App.actions.closeModal(constants.ADDITIONAL_MEASUREMENTS_MODAL)),
        onOpenFloatingModal: ()=>dispatch(App.actions.openFloatingModal(constants.ADDITIONAL_MEASUREMENTS_FM, 'additionalMeasurementsContainer', 'leftTop')),
        onCloseFloatingModal: ()=>dispatch(App.actions.closeFloatingModal(constants.ADDITIONAL_MEASUREMENTS_FM))
    });
const ConnectedAdditionalMeasurementsBtn = connect(mapStateToProps, mapDispatchToProps)(AdditionalMeasurementsBtn);
export default ConnectedAdditionalMeasurementsBtn;
